export const iconFontAwesomeFilmVideoPodcast = (
	<i className="fa-solid fa-podcast"></i>
);
